import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../api/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../auth/auth-context';

export default function AddUserModal({ orgId, onClose, onAdded }) {
  const navigate = useNavigate();
  const { issuperadmin } = useAuth();

  const [email, setEmail] = useState('');
  const [role, setRole] = useState('org:view');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    if (!email) return;

    setBusy(true);
    setError(null);

    try {
      const res = await apiFetch(`/org/${orgId}/users`, {
        method: 'POST',
        body: { email, role }
      });

      if (res.status === 'INVITED') {
        toast.success(`Invitation sent to ${email}`);
      } else {
        toast.success('User added to organization');
      }

      // Option A: user not registered yet
      if (res?.status === 'NOT_REGISTERED') {
        navigate(
          `/register/new?inviteOrgId=${orgId}&email=${encodeURIComponent(
            email
          )}&role=${role}`
        );
        return;
      }

      // ✅ success — let parent refresh users + close modal
      onAdded?.();
      onClose?.();
    } catch (err) {
      setError(err.message || 'Failed to add user');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal">
      <div className="modal-header">
        <h3>Add User</h3>
      </div>

      <div className="modal-body">
      <div className="form-group">
        <label>Email Address:</label>
        <input
          type="email"
          className="form-input"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Role:&nbsp;&nbsp;</label>
        <select
          className="form-input"
          value={role}
          onChange={e => setRole(e.target.value)}
        >
          {issuperadmin && (
            <option value="org:owner">Owner</option>
          )}
          <option value="org:user">User</option>
          <option value="org:admin">Admin</option>
        </select>
      </div>


        {error && <div className="form-error">{error}</div>}
      </div>

      <div className="modal-actions">
        <button className="btn secondary" onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn primary"
          onClick={submit}
          disabled={busy}
        >
          {busy ? 'Adding…' : 'Add User'}
        </button>
      </div>
    </div>
  );
}
